import { init } from './modules/_textarea_scroll.js';

window.auguste = window.auguste || {};
window.auguste.TextareaScroll = { init };
